export default "__VITE_PUBLIC_ASSET__bd0cb209__"